// PWA временно отключена (VitePWA disabled в vite.config.ts, /sw.js → 410 в nginx.conf).
// Причина: у установленных в браузерах старых Service Worker'ов NavigationRoute
// перехватывал навигацию и обслуживал устаревшую сборку — login-фикс не подхватывался.
// Здесь оставлена только активная выписка любых ранее зарегистрированных SW, чтобы
// ускорить деактивацию старого SW у пользователей. Регистрация нового SW не происходит.

export function initPWA() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((r) => r.unregister().then(() => console.log('SW unregistered', r.scope)));
    });
  }
}
